module.exports = __webpack_public_path__ + "static/media/PaymentInitiatedBIG.96d1016c.svg";